module.exports = __webpack_public_path__ + "kg.svg?300e8630f2c5b3b3a96619ffa5bec5ee";